let foundForm = false;

function safeTrackLead() {
  try {
    if (typeof fbq === 'function') fbq('track', 'Lead');
  } catch (e) {
    // Don't break form submit if tracking fails
    console.warn('[vedkungen_formhelper] fbq track failed', e);
  }
}

function attachFormListener(formEl) {
  if (!formEl) return false;
  if (formEl.dataset.vedkungenFormhelperBound === 'true') return true;

  formEl.addEventListener('submit', function () {
    console.log('[vedkungen_formhelper] form submitted');
    safeTrackLead();
  });

  formEl.dataset.vedkungenFormhelperBound = 'true';
  return true;
}

function findFormInRoot(root) {
  if (!root) return null;

  // Prefer explicit Shopify Forms selector if present
  const direct =
    root.querySelector?.('#form form') ||
    root.querySelector?.('form[data-testid="form"]') ||
    root.querySelector?.('#form [data-testid="form"]') ||
    root.querySelector?.('#form form[data-testid="form"]');

  if (direct) return direct;

  // Traverse open shadow roots (Shopify Forms embed uses Shadow DOM)
  const walker = (node) => {
    if (!node) return null;

    // If this node is a form, return it
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'FORM') return node;

    // Search in this node's shadow root (open only)
    const sr = node.shadowRoot;
    if (sr) {
      const inShadow =
        sr.querySelector('form[data-testid="form"]') ||
        sr.querySelector('form') ||
        null;
      if (inShadow) return inShadow;

      // Recurse into shadow children too
      for (const child of Array.from(sr.children)) {
        const found = walker(child);
        if (found) return found;
      }
    }

    // Recurse normal DOM children
    if (node.children) {
      for (const child of Array.from(node.children)) {
        const found = walker(child);
        if (found) return found;
      }
    }

    return null;
  };

  return walker(root);
}

function init() {
  // Try immediately (in case it's already in DOM)
  const root = document.querySelector('#form') || document.body;
  const initial = findFormInRoot(root);
  if (attachFormListener(initial)) return;

  // Wait for async-rendered form
  const observer = new MutationObserver(() => {
    const found = findFormInRoot(root);
    console.log('[vedkungen_formhelper] found form', found);
    foundForm = true;
    if (attachFormListener(found)) observer.disconnect();
  });

  observer.observe(root, { childList: true, subtree: true });

  // Safety: stop observing after 2s
  setTimeout(() => {
    if (!foundForm) console.warn('[vedkungen_formhelper] could not find form');
    observer.disconnect();
  }, 2_000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
